import { useEffect, useState } from "react";

/**
 * Generic debounce hook.
 * Returns a debounced copy of the value that updates after `delay` ms.
 */
export function useDebounce<T>(value: T, delay = 350): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
